import { render, staticRenderFns } from "./menu_item.vue?vue&type=template&id=450423b9&scoped=true&"
import script from "./menu_item.vue?vue&type=script&lang=js&"
export * from "./menu_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450423b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450423b9')) {
      api.createRecord('450423b9', component.options)
    } else {
      api.reload('450423b9', component.options)
    }
    module.hot.accept("./menu_item.vue?vue&type=template&id=450423b9&scoped=true&", function () {
      api.rerender('450423b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/dashboard/menu_item.vue"
export default component.exports